require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-dg-7-xg.json") })
        }
      }, "path---photos-professional-dg-7-xg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-dg-7-xg!./.cache/json/photos-professional-dg-7-xg.json
// module id = 730
// module chunks = 231608221292675